export default "__VITE_ASSET__15a5b9e7__"